import { month } from "../en/commApp/monthlyHealthReport"

export {
    month
}


// WEBPACK FOOTER //
// ./src/assets/i18n/config/en.js